import { environment } from '../../../../environments/environment';
import { BookedQuantity } from './booked-quantity';

export class BookingSlot {
  private _id: number;
  private _areaId: number;
  private _bookingDate: Date;
  private _fromTime: number;
  private _toTime: number;
  private _capacity: number;
  private _bookedQuantity: number;
  private _minPrice: number;
  private _nextSlotValid: number;
  areaItemsIds: number[];
  private _bookedDetailQuantity: BookedQuantity[];

  constructor(
    id: number,
    areaId: number,
    bookingDate: Date,
    fromTime: number,
    toTime: number,
    capacity: number,
    bookedQuantity: number,
    minPrice?: number,
    nextSlotValid?: number,
    bookedDetailQuantity?: BookedQuantity[]
  ) {
    this._id = id;
    this._areaId = areaId;
    this._bookingDate = bookingDate;
    this._fromTime = fromTime;
    this._toTime = toTime;
    this._capacity = capacity;
    this._minPrice = minPrice;
    this._bookedQuantity = bookedQuantity;
    this._nextSlotValid = nextSlotValid;
    this._bookedDetailQuantity = bookedDetailQuantity;
  }

  static createFromAny(object: any): BookingSlot {
    if (object === null || object === undefined) {
      return null;
    }

    return new BookingSlot(
      object.id,
      object.areaId,
      new Date(object.bookingDate),
      object.fromTime,
      object.toTime,
      object.capacity,
      object.bookedQuantity,
      object.minPrice,
      object.nextSlotValid,
      object.bookedDetailQuantity ? object.bookedDetailQuantity.map(item => BookedQuantity.createFromAny(item)) : null,
    );
  }

  get id(): number {
    return this._id;
  }

  get areaId(): number {
    return this._areaId;
  }

  get bookingDate(): Date {
    return this._bookingDate;
  }

  get fromTime(): number {
    return this._fromTime;
  }

  get toTime(): number {
    return this._toTime;
  }

  get capacity(): number {
    return this._capacity;
  }

  get minPrice(): number {
    return this._minPrice;
  }

  set minPrice(value: number) {
    this._minPrice = value;
  }

  get bookedQuantity(): number {
    return this._bookedQuantity;
  }

  get freeQuantity(): number {
    return this._capacity - this._bookedQuantity;
  }

  get slotDurationTime(): number {
    return this._toTime - this._fromTime;
  }

  get slotDurationTimeMinutes(): number {
    return (this._toTime - this._fromTime) * 60;
  }

  get minPriceStr(): string {
    return environment.globalSettings.toMoneyStr(this._minPrice);
  }

  get nextSlotValid(): number {
    return this._nextSlotValid;
  }

  toString(): string {
    return environment.globalSettings.toTimeString(this._fromTime);
  }

  get bookedDetailQuantity(): BookedQuantity[] {
    return this._bookedDetailQuantity;
  }

  get availableAreaItemsIds(): number[] {
    if (!this.bookedDetailQuantity) {
      return [];
    }

    return this.bookedDetailQuantity.filter(item => this.areaItemsIds.includes(item.areaItemId)).map(item => item.areaItemId);
  }
}
